import styled from 'styled-components';

import { NavLinkWithPopoverStyles } from '../NavLink.types';
import { DarkTheme, LightTheme, ThemeType } from 'src/packages/theme';

export const getNavlinkWithPopoverStyles = (theme: ThemeType): NavLinkWithPopoverStyles => {
  return {
    popoverMenuBgColor:
      theme === 'light'
        ? LightTheme.colors.background.secondary.BG3
        : DarkTheme.colors.background.secondary.BG3,
    menuItemBgColorHover:
      theme === 'light'
        ? LightTheme.colors.background.secondary.BG4
        : DarkTheme.colors.background.secondary.BG4,
    menuItemLabelColor:
      theme === 'light' ? LightTheme.colors.text.primary : DarkTheme.colors.text.primary,
    menuItemLabelColorHover:
      theme === 'light' ? LightTheme.colors.palette.primary : DarkTheme.colors.palette.primary,
    menuItemSublabelColor:
      theme === 'light' ? LightTheme.colors.text.tertiary : DarkTheme.colors.text.tertiary,
    iconColor: theme === 'light' ? LightTheme.colors.text.primary : DarkTheme.colors.text.primary,
  };
};

export const NavLinkWithPopoverContainer = styled.div`
  position: relative;

  .main-link-label {
    transition: color 0.2s ease-in;

    * {
      transition: color 0.2s ease-in;
    }

    &:hover {
      * {
        transition: color 0.2s ease-in;
        color: ${(props) => props.theme.colors.palette.primary};
      }

      svg {
        path[stroke] {
          stroke: ${(props) => props.theme.colors.palette.primary};
        }

        path[fill] {
          fill: ${(props) => props.theme.colors.palette.primary};
        }
      }
    }
  }
`;

export const MenuWrapper = styled.div`
  position: absolute;
  top: 23px;
  left: -100%;
  padding-top: 15px;
`;

export const LinksMenu = styled.div<{
  popoverMenuBgColor: string;
  menuItemBgColorHover: string;
  menuItemLabelColorHover: string;
}>`
  display: flex;
  width: max-content;
  box-shadow: 0 1px 6px -2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  overflow: hidden;

  ul {
    list-style: none;
    background-color: ${(props) => props.popoverMenuBgColor};
    padding: 10px;
    margin: 0;
    width: 100%;

    a {
      padding: 14px 10px;
      margin: 0;
      min-width: 160px;
      border-radius: 6px;
      width: 100%;
      cursor: pointer;

      * {
        transition: color 0.2s ease-in;
      }

      svg {
        &.red {
          path[stroke] {
            stroke: ${(props) => props.theme.colors.palette.red} !important;
          }

          path[fill] {
            fill: ${(props) => props.theme.colors.palette.red} !important;
          }
        }

        &.orange {
          path[stroke] {
            stroke: ${(props) => props.theme.colors.palette.orange} !important;
          }

          path[fill] {
            fill: ${(props) => props.theme.colors.palette.orange} !important;
          }
        }
      }

      &:hover {
        background-color: ${(props) => props.menuItemBgColorHover};

        * {
          cursor: pointer;
          transition: color 0.2s ease-in;
        }

        .link-item-label {
          color: ${(props) => props.menuItemLabelColorHover};
        }
      }
    }
  }
`;
